import DashboardIcon from "@mui/icons-material/DashboardOutlined";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EmailIcon from '@mui/icons-material/MailOutlineRounded';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Box, Button, Collapse, Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, { useState } from "react";
import { ReactComponent as LinkedInIcon } from "../../../assets/icons/linkedin.svg";
import theme from "../../../theme";
import CaptureLinkedIn from "../../atoms/CaptureLinkedIn";
import ForwardDeals from "../../atoms/ForwardDeals";

const useStyles = makeStyles((theme) => ({
    card: {
        position: 'relative',
        minWidth: 325,
        width: '100%',
        height: 'fit-content',
        minHeight: 80,
        padding: '12px 16px',
        borderRadius: 16,
        backgroundColor: '#fff',
        border: `1px solid ${theme.colors.neutral['400']}`,
        boxShadow: '0px 3px 5px -1px rgba(16, 24, 40,0.2)',
        transition: 'all 300ms ease-in-out',
    },
    mainIcon: {
        padding: 0,
        "& > svg": {
            width: '28px !important',
            height: '28px !important'
        },
    },
    subIcon: {
        width: 24,
        height: 24,
        fill: theme.colors.neutral['400'],
    },
    leftBulletIcon: {
        width: 24,
        height: 24,
        fill: theme.colors.primary['300'],
        backgroundColor: '#fff',
        transform: 'translateX(-12px)',
    },
    longLine: {
        width: '100%',
        borderBottom: `3px solid ${theme.colors.primary['200']}`,
        marginLeft: '-16px',
        marginRight: '-12px',
        zIndex: 1,
    },
    rightArrowIcon : {
        width: 32,
        height: 32,
        fill: theme.colors.primary['300'],
        zIndex: 1,
    },
    title: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: '#666666',
    },
    label: {
        fontFamily: 'Inter',
        fontSize: '0.95rem',
        fontWeight: 500,
        color: theme.colors.neutral['500'],
    },
}));

const NewCompany: React.FC<{}> = () => {
    const classes = useStyles();
    const [isExpandEmail, setExpandEmail] = useState<boolean>(false);
    const [isExpandLinkedIn, setExpandLinkedIn] = useState<boolean>(false);

    return (<>
        <Stack direction="row" alignItems="center" justifyContent="flex-start" width="100%" pl={2}>
            <Stack className={classes.card} spacing={1} alignItems="flex-start">
                <Stack direction="row" spacing={1} alignItems="center" width="100%">
                    <DashboardIcon className={classes.mainIcon} />
                    <Stack spacing="4px" alignItems="flex-start" width="100%">
                        <Typography className={classes.title}>
                            {'New Company'}
                        </Typography>
                    </Stack>
                </Stack>
                <Stack spacing={1} alignItems="flex-start" width="100%" pl={4}>
                    <Typography fontFamily="Inter" color={theme.colors.neutral['500']} fontWeight={600}>
                        {'From: '}
                    </Typography>
                    <Stack spacing={1} alignItems="flex-start" width="100%">
                        <Stack direction="row" spacing={1} alignItems="flex-start">
                            <EmailIcon className={classes.subIcon} />
                            <Typography className={classes.label}>
                                {'Email'}
                            </Typography>
                            <Button variant="text"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setExpandEmail((prev) => !prev);
                                }}
                                sx={{ minWidth: 'unset', padding: 'unset' }}>
                                <ExpandMoreIcon sx={{ fill: '#666666', transform: `rotate(${isExpandEmail ? 180 : 0}deg)` }} />
                            </Button>
                        </Stack>
                        <Box width="100%" height="fit-content">
                            <Collapse in={isExpandEmail} collapsedSize={0} sx={{ marginLeft: -1}}>
                                <ForwardDeals label="Forward deals in email to: " color="#7bd4d4" />
                            </Collapse>
                        </Box>
                    </Stack>
                    <Stack spacing={1} alignItems="flex-start" width="100%">
                        <Stack direction="row" spacing={1} alignItems="flex-start">
                            <LinkedInIcon className={classes.subIcon} />
                            <Typography className={classes.label}>
                                {'LinkedIn'}
                            </Typography>
                            <Button variant="text"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setExpandLinkedIn((prev) => !prev);
                                }}
                                sx={{ minWidth: 'unset', padding: 'unset' }}>
                                <ExpandMoreIcon sx={{ fill: '#666666', transform: `rotate(${isExpandLinkedIn ? 180 : 0}deg)` }} />
                            </Button>
                        </Stack>
                        <Box width="100%" height="fit-content">
                            <Collapse in={isExpandLinkedIn} collapsedSize={0} sx={{ marginLeft: -1}}>
                                <CaptureLinkedIn />
                            </Collapse>
                        </Box>
                    </Stack>
                </Stack>
            </Stack>
            <Stack direction="row" alignItems="center" width="100%" height="100%">
                <RadioButtonUncheckedIcon className={classes.leftBulletIcon} />
                <Box className={classes.longLine} />
                <PlayArrowIcon className={classes.rightArrowIcon} />
            </Stack>
        </Stack>
    </>);
}

export default NewCompany;
